import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const settingsPanelStyleId = 'wb-v2-settings-panel-theme';

export const settingsPanelBridgeStyles = {
  'wb-settings-panel': {
    // Background
    '--local-sp-bg': tokens.color.background.primary,

    // Header (consistent across main + sub pages)
    '--local-sp-header-px': tokens.spacing.twoXl,
    '--local-sp-header-py': tokens.spacing.mdAlt,
    '--local-sp-header-gap': tokens.spacing.lg,

    // Back button (sub-page only)
    '--local-sp-back-color': tokens.color.foreground.secondary,
    '--local-sp-back-hover-bg': tokens.color.background.primaryHover,
    '--local-sp-back-radius': tokens.radius.sm,
    '--local-sp-back-padding': tokens.spacing.sm,
    '--local-sp-back-icon-size': '20px',

    // Title (shared)
    '--local-sp-title-font-family': tokens.font.family.display,
    '--local-sp-title-font-size': tokens.font.size.displayXs,
    '--local-sp-title-font-weight': tokens.font.weight.semibold,
    '--local-sp-title-line-height': tokens.lineHeight.displayXs,
    '--local-sp-title-color': tokens.color.text.primary,

    // Body
    '--local-sp-body-px': tokens.spacing.twoXl,
    '--local-sp-body-pt': tokens.spacing.mdAlt,
    '--local-sp-body-pb': tokens.spacing.twoXl,

    // Item row
    '--local-sp-item-row-gap': tokens.spacing.xl,
    '--local-sp-item-list-gap': tokens.spacing.lg,
    '--local-sp-item-hover-bg': tokens.color.background.primaryHover,
    '--local-sp-item-hover-radius': tokens.radius.sm,
    '--local-sp-command-palette-item-hover-bg': tokens.color.background.primaryHover,
    '--local-sp-command-palette-item-active-bg': tokens.color.background.tertiary,

    // Item icon
    '--local-sp-item-icon-size': '20px',
    '--local-sp-item-icon-color': tokens.color.foreground.secondary,

    // Item label (fixed-width left column)
    '--local-sp-label-width': '136px',
    '--local-sp-label-font-family': tokens.font.family.body,
    '--local-sp-label-font-size': tokens.font.size.textMdBase,
    '--local-sp-label-font-weight': tokens.font.weight.regular,
    '--local-sp-label-line-height': tokens.lineHeight.textMd,
    '--local-sp-label-color': tokens.color.text.secondary,

    // Item value area (right pill)
    '--local-sp-value-bg': tokens.color.background.tertiary,
    '--local-sp-value-radius': tokens.radius.sm,
    '--local-sp-value-px': tokens.spacing.lg,
    '--local-sp-value-py': tokens.spacing.sm,
    '--local-sp-value-gap': tokens.spacing.sm,
    '--local-sp-value-font-family': tokens.font.family.body,
    '--local-sp-value-font-size': tokens.font.size.textMdBase,
    '--local-sp-value-font-weight': tokens.font.weight.medium,
    '--local-sp-value-line-height': tokens.lineHeight.textMd,
    '--local-sp-value-color': tokens.color.text.primary,
    '--local-sp-value-count-font-weight': tokens.font.weight.medium,

    // Chevron (inside value area)
    '--local-sp-chevron-size': '12px',
    '--local-sp-chevron-color': tokens.color.foreground.quaternary,

    // Group section header (e.g. "Jobs actions" / "Stages actions" in bulk-actions palette)
    '--local-sp-group-px': tokens.spacing.lg,
    '--local-sp-group-pt': tokens.spacing.xl,
    '--local-sp-group-pb': tokens.spacing.sm,
    '--local-sp-group-font-family': tokens.font.family.body,
    '--local-sp-group-font-size': tokens.font.size.textSm,
    '--local-sp-group-font-weight': tokens.font.weight.medium,
    '--local-sp-group-line-height': tokens.lineHeight.textSm,
    '--local-sp-group-color': tokens.color.text.quaternary,

    // Keyboard focus ring — applied as box-shadow on :focus-visible
    '--local-sp-focus-ring': tokens.focusRing.default,
    '--local-sp-focus-ring-color': tokens.color.border.brand,
    '--local-sp-focus-ring-width': tokens.borderWidth.md,

    // Reserved space when scrolling a focused row into view (above header/below footer).
    '--local-sp-scroll-padding': tokens.spacing.twoXl,
  },
};
